import React, {useId} from "react";
import {observer} from "mobx-react-lite";
import {Checkbox as CheckBoxPrime} from "primereact/checkbox";

import systemStore from "../storage/SystemStore";


const CheckBox = ({
    label,
    store,
    prop,
    checked,
    onChange,
    inputId,
    name,
    required = false,
    disabled = false,
    invalid: invalidProp,
    className = "",
    wrapperClassName = "",
    ...rest
}) => {
    const generatedId = useId();

    const storeBound =
        store !== undefined &&
        prop !== undefined;


    const currentChecked =
        checked !== undefined
            ? Boolean(checked)
            : storeBound
                ? Boolean(store[prop])
                : false;


    const invalid =
        invalidProp ??
        (
            required &&
            storeBound &&
            Boolean(store?.was_validated) &&
            !currentChecked
        );


    const id =
        inputId ||
        `checkbox-${generatedId.replace(/:/g, "")}`;


    const handleChange = (event) => {
        const value = Boolean(event.checked);

        if (storeBound) {
            store.setProperty(prop, value);
        }

        onChange?.(value, event);
    };


    return (
        <div
            className={[
                "flex align-items-center",
                wrapperClassName,
            ]
                .filter(Boolean)
                .join(" ")}
        >
            <CheckBoxPrime
                {...rest}

                inputId={id}
                name={name || prop}

                checked={currentChecked}

                disabled={
                    disabled ||
                    systemStore.loading
                }

                invalid={invalid}

                className={className}

                onChange={handleChange}
            />


            {label && (
                <label
                    htmlFor={id}
                    className="ml-2"
                >
                    {label}
                </label>
            )}
        </div>
    );
};


export default observer(CheckBox);